import { createAsyncThunk } from '@reduxjs/toolkit';
import { API_AUTH_SOCO } from '~global-api/soco.api';
import md5 from 'md5';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
dayjs.extend(timezone);
const gtmInitialize = async (dataUser) => {
  try {
    if (dataUser) {
      const {
        my_sql_id: userID = '',
        _id: userIDMongo = '',
        email: userEmail = '',
        user_name: userName = '',
        first_name: userFirstname = '',
        last_name: userLastname = '',
        date_of_birth: userBirth = '',
        gender: userGender = '',
        phone_no: userPhone = '',
      } = dataUser;
      const hashedEmail = md5(userEmail);
      const data = {
        event: 'loggedIn',
        user_id: userID,
        user_id_mongo: userIDMongo,
        user_data: {
          userID,
          userIDMongo,
          userEmail,
          hashedEmail,
          userName,
          userFirstname,
          userLastname,
          userBirth,
          userGender,
          userPhone,
        },
      };
      window.dataLayer.push(data);
    }
  } catch (err) {
    console.log(err);
  }
};

export const postLogin = createAsyncThunk('auth/postLogin', async (payload) => {
  try {
    const response = await API_AUTH_SOCO('post', '/login', {
      ...payload,
      source: 'soco-web-desktop',
    });
    if (response.data.data.user) {
      gtmInitialize(response.data.data.user);
      setUserTracking(response.data.data.user);
    }

    return {
      data: response.data,
      type: 'success',
    };
  } catch (error) {
    return {
      data: error?.response.data,
      type: 'error',
    };
  }
});

export const getLogout = createAsyncThunk('auth/getLogout', async () => {
  try {
    const response = await API_AUTH_SOCO('get', '/logout');
    clearUserTracking();
    return response.data;
  } catch (error) {
    return error.response.data;
  }
});

const getCookie = (cookieName) => {
  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      const result = cookie.substring(name.length, cookie.length);
      try {
        return JSON.parse(result);
      } catch (error) {
        return result;
      }
    }
  }
  return null;
};

const setUserTracking = (user) => {
  try {
    const userID = user && Object.keys(user).length ? user.my_sql_id : '';
    const userIDMongo = user && Object.keys(user).length ? user._id : '';
    const userEmail = user && Object.keys(user).length ? user.email : '';
    const hashedEmail = user && Object.keys(user).length ? md5(user.email) : '';
    // const hashed256Email =
    //   user && Object.keys(user).length
    //     ? crypto.createHash('sha256').update(user.email).digest('hex')
    //     : '';
    const userName = user && Object.keys(user).length ? user.user_name : '';
    const userFirstname =
      user && Object.keys(user).length ? user.first_name : '';
    const userLastname = user && Object.keys(user).length ? user.last_name : '';
    const userBirth =
      user && Object.keys(user).length && 'date_of_birth' in user
        ? dayjs(user.date_of_birth).format('DD-MM-YYYY')
        : '';
    const userBirthInsider =
      user && Object.keys(user).length && 'date_of_birth' in user
        ? dayjs(user.date_of_birth).tz('Asia/Jakarta').format('YYYY-MM-DD')
        : '';
    const userGender =
      user && Object.keys(user).length && 'gender' in user ? user.gender : '';
    const userPhone =
      user && Object.keys(user).length && 'phone_no' in user
        ? user.phone_no
        : '';
    const userPhoneE164 =
      user && Object.keys(user).length && 'phone_no_e164' in user
        ? user.phone_no_e164
        : '';
    // const hashed256Phone =
    //   user && Object.keys(user).length && 'phone_no_e164' in user
    //     ? crypto.createHash('sha256').update(user.phone_no_e164).digest('hex')
    //     : '';
    const userCountry =
      user && Object.keys(user).length && 'country' in user
        ? user.country.name
        : '';
    const userProvince =
      user && Object.keys(user).length && 'province' in user
        ? user.province.name
        : '';
    const userCity =
      user && Object.keys(user).length && 'city' in user ? user.city.name : '';
    const userDistrict =
      user && Object.keys(user).length && 'district' in user
        ? user.district.name
        : '';
    const userCountryDefault =
      user && Object.keys(user).length && 'country' in user
        ? user.country.name
        : '';
    const userLevel =
      user && Object.keys(user).length && 'level' in user
        ? user.level?.current?.stage
        : '';
    const soco_points =
      user && Object.keys(user).length && 'points' in user
        ? user.points?.count
        : 0;
    const is_verified_email =
      user && Object.keys(user).length && 'is_verified_email' in user
        ? user.is_verified_email
        : false;
    const is_verified_phone =
      user && Object.keys(user).length && 'is_verified_phone' in user
        ? user.is_verified_phone
        : false;
    const beauty_created_at =
      user && Object.keys(user).length && 'beauty_created_at' in user
        ? true
        : false;
    const sessionId = getCookie('SOCIOLLA_SESSION_ID');
    const beauty = user?.beauty || [];
    let warnaKulit = '';
    let undertone = '';
    let jenisKulit = '';
    let kondisiKulit = '';
    let warnaRambut = '';
    let kondisiRambut = '';
    beauty.forEach((b) => {
      if (b.name === 'warna-kulit') {
        warnaKulit = b.subtags[0].name;
      } else if (b.name === 'undertone') {
        undertone = b.subtags[0].name;
      } else if (b.name === 'jenis-kulit') {
        jenisKulit = b.subtags?.map((st) => st.name).join(', ') || '';
      } else if (b.name === 'kondisi-kulit') {
        kondisiKulit = b.subtags?.map((st) => st.name).join(', ') || '';
      } else if (b.name === 'warna-rambut') {
        warnaRambut = b.subtags[0].name;
      } else if (b.name === 'kondisi-rambut') {
        kondisiRambut = b.subtags?.map((st) => st.name).join(', ') || '';
      }
    });

    setTimeout(() => {
      window.dataLayer.push({
        event: 'loggedIn',
        user_id: userID,
        user_id_mongo: userIDMongo,
        user_data: {
          userID,
          userIDMongo,
          userEmail,
          hashedEmail,
          // hashed256Email,
          userName,
          userFirstname,
          userLastname,
          userBirth,
          userGender,
          userPhone,
          userPhoneE164,
          // hashed256Phone,
          userCountry,
          userLevel,
          soco_points,
          is_verified_email,
          is_verified_phone,
          beauty_created_at,
          userProvince,
          userCity,
          userDistrict,
          userBirthInsider,
          userCountryDefault,
          sessionId,
          warnaKulit,
          undertone,
          jenisKulit,
          kondisiKulit,
          warnaRambut,
          kondisiRambut,
        },
      });
    }, 400);
  } catch (error) {
    console.error(error);
  }
};

const clearUserTracking = () => {
  try {
    window.dataLayer.push({
      user_id: '',
      user_id_mongo: '',
      user_data: {
        userID: '',
        userIDMongo: '',
        userEmail: '',
        hashedEmail: '',
        userName: '',
        userFirstname: '',
        userLastname: '',
        userBirth: '',
        userGender: '',
        userPhone: '',
        userPhoneE164: '',
        userCountry: '',
        userLevel: '',
        soco_points: 0,
        is_verified_email: false,
        is_verified_phone: false,
        beauty_created_at: false,
        userProvince: '',
        userCity: '',
        userDistrict: '',
        userBirthInsider: '',
        userCountryDefault: '',
        sessionId: '',
        warnaKulit: '',
        undertone: '',
        jenisKulit: '',
        kondisiKulit: '',
        warnaRambut: '',
        kondisiRambut: '',
      },
    });

    if (typeof window !== 'undefined' && window.insider_object) {
      if (window.insider_object.user) {
        delete window.insider_object.user;
      }
      if (window.insider_object.basket) {
        delete window.insider_object.basket;
      }
    }
    removeCookie('SOCIOLLA_SESSION_ID');
  } catch (error) {
    console.error('Error clearing user tracking:', error);
  }
};

const removeCookie = (cookieName, options = {}) => {
  try {
    const { path = '/', domain = '', secure = false, sameSite = '' } = options;
    let cookieString = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}`;

    if (domain) {
      cookieString += `; domain=${domain}`;
    }
    if (secure) {
      cookieString += '; secure';
    }
    if (sameSite) {
      cookieString += `; samesite=${sameSite}`;
    }

    document.cookie = cookieString;
    return true;
  } catch (error) {
    console.error(`Error removing cookie ${cookieName}:`, error);
    return false;
  }
};
